import MarketingSourceLogo from 'common/components/icons/marketingSourceLogo';
import { filterOutNonViewableFields } from 'common/components/table/cell-formatters/fieldHelpers';
import { FC, Fragment } from 'react';
import { FieldCell } from './fieldCell';
import Blur from 'features/blur/blur';

export interface PayloadFieldsCellFormatterProps {
  fieldObject: {
    header: string;
    subheader: string | undefined;
    fields: Map<string, string>;
  };
  icon: string;
  additionalFieldsFilter: (fields: [string, any][]) => [string, any][];
}

export const PayloadFieldsCellFormatter: FC<
  PayloadFieldsCellFormatterProps
> = ({
  fieldObject: { header, subheader, fields },
  additionalFieldsFilter
}) => {
  if (!fields) {
    return null;
  }
  const filteredFields = additionalFieldsFilter(
    filterOutNonViewableFields(Object.entries(fields))
  );

  return (
    <div className="flex flex-col items-left flex-wrap my-1 truncate">
      <div className="flex items-center">
        <MarketingSourceLogo
          marketingSource={header}
          imageClasses="w-4 h-4 mr-1"
          iconClasses="text-lg flex mr-1"
        />
        <div>{header}</div>
      </div>
      {subheader ? (
        <a
          href={`//${subheader}`}
          target="_blank"
          rel="noreferrer"
          className="text-sm text-primary-100 italic pl-2 hover:underline"
        >
          <span>{subheader}</span>
        </a>
      ) : (
        <></>
      )}
      <Blur>
        {filteredFields.map(([_, { key, value }], index) => {
          return (
            <Fragment key={`fields_col_${header}_${index}`}>
              <FieldCell identifier={key} value={value} />
            </Fragment>
          );
        })}
      </Blur>
    </div>
  );
};
